import { useDispatch, useSelector } from "react-redux";
import { ReducersTypes } from "../../../redux/reducers/Models";
import { validateEmail } from "@/utils/functions";
import RegisterUserView from "./view";
import { useNavigate } from "react-router-dom";
import { setCustomer } from "@/redux/ducks/customer";
import moment from "moment";

export default function RegisterUser() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);

  const goBack = () => navigate(-1);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dispatch(
      setCustomer({
        register: {
          ...customer?.register,
          [name]: value,
        },
      }),
    );
  };

  const getIsDisabled = () => {
    const birthdate = moment(customer?.register?.birthdate, "DD/MM/YYYY", true);
    if (
      !customer?.register?.name ||
      !validateEmail(customer?.register?.email!) ||
      !birthdate.isValid() ||
      moment().diff(birthdate, "years") < 18
    )
      return true;
    return false;
  };

  const goToAddress = () => {
    if (getIsDisabled()) return;

    navigate("/register/address");
  };

  return (
    <RegisterUserView
      goBack={goBack}
      customer={customer}
      onChange={onChange}
      goToAddress={goToAddress}
      isDisabled={getIsDisabled()}
    />
  );
}
